export default {
  meta: {
    title: '拓店管理-计划调整',
  }
};
